export default {
    components : {
      contact_form : {
        honeypot_error : 'Molimo vas da ne koristite alate za automatsko slanje.'
      }
    },
    contactForm : {
      name : "Ime",
      phone : "Telefon",
      email : "Email",
      message : "Detalji:",
      date : 'Datum',
      persons : 'Broj osoba',
      send : 'Pošalji',
      error : 'Greška',
      sending : 'Slanje',
      sent : 'Poslato',
      toastr : {
        error : 'Greška pri slanju poruke',
        nameRequired : 'Molimo navedite ime',
        emailRequired : 'Molimo navedite email',
        recaptchaFailed : 'Greška! Molimo pokušajte ponovo.'
      }
    }
}
